if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      async confirmBackorder() {
        const stock = this.querySelector('[data-backorder-stock]');
        if (!stock) return true;
        const variantId = this.form.querySelector('[name="id"]').value;
        const variant = [...stock.children].find((item) => item.dataset.variantId === variantId);
        if (!variant || variant.dataset.tracked !== 'true') return true;
        const quantity = Number(new FormData(this.form).get('quantity') || 1);
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!response.ok) throw new Error(this.querySelector('[data-backorder-error]').dataset.backorderError);
        const cart = await response.json();
        const existing = cart.items.filter((item) => String(item.variant_id) === variantId).reduce((sum, item) => sum + item.quantity, 0);
        const total = existing + quantity;
        const ready = Math.max(0, Number(variant.dataset.quantity));
        if (total <= ready) return true;
        const dialog = this.querySelector('[data-backorder-template]').content.firstElementChild.cloneNode(true);
        const labels = this.querySelector('[data-backorder-count-label]').dataset;
        dialog.querySelector('[data-backorder-identity]').textContent = `${variant.dataset.brand} — ${labels.backorderSkuLabel} ${variant.dataset.sku}`;
        dialog.querySelector('[data-backorder-title]').textContent = variant.dataset.title;
        dialog.querySelector('[data-backorder-option]').textContent = variant.dataset.option;
        dialog.querySelector('[data-backorder-counts]').textContent = labels.backorderCountLabel.replace('{ready}', Math.min(ready, total)).replace('{delayed}', total - ready).replace('{total}', total);
        const previousFocus = document.activeElement;
        document.body.append(dialog);
        const accepted = await new Promise((resolve) => {
          dialog.addEventListener('close', () => resolve(dialog.returnValue === 'add'), { once: true });
          dialog.querySelector('[data-backorder-add]').addEventListener('click', () => dialog.close('add'));
          dialog.querySelector('[data-backorder-cancel]').addEventListener('click', () => dialog.close('cancel'));
          dialog.addEventListener('click', (event) => {
            if (event.target !== dialog) return;
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close('cancel');
          });
          dialog.showModal();
        });
        dialog.remove();
        previousFocus?.focus();
        return accepted && this.isConnected && this.form.querySelector('[name="id"]').value === variantId && Number(new FormData(this.form).get('quantity') || 1) === quantity;
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        if (this.confirmationPending) return;
        this.confirmationPending = true;
        try {
          if (!(await this.confirmBackorder())) return;
        } catch (error) {
          this.handleErrorMessage(error.message);
          return;
        } finally {
          this.confirmationPending = false;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                item: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
